<script lang="ts">
  export let value: any;
</script>

<span class="value">{value}</span>

<style>
  .value {
    font-weight: bold;    
  }
</style>